import { useEffect, useState } from 'react';
import type { StepProps } from './context';

/**
 * Blind listening happens on the video itself, so this panel stays small:
 * captions off, play/pause, and the gist question only after listening (or on request).
 */
export function Gist({ detail, state, listened, update, complete, setMode, togglePlay, playing }: StepProps) {
  const quiz = detail.lesson.gist;
  const [picked, setPicked] = useState<number | null>(state.gistAnswer ?? null);
  const [showQuiz, setShowQuiz] = useState(picked !== null);
  const [choice, setChoice] = useState<number | null>(picked);
  const submitted = picked !== null;
  useEffect(() => setMode('none'), [setMode]);
  useEffect(() => {
    if (listened) setShowQuiz(true);
  }, [listened]);
  const done = state.steps.gist?.done;

  return (
    <div className="step-body">
      <p className="gist-lead">
        字幕已关闭。完整听一遍，只抓大意：<b>在聊什么？结论是什么？</b>
      </p>
      <div className="row wrap">
        <button className="primary" onClick={togglePlay}>
          {playing ? '❚❚ 暂停' : '▶ 播放'}
        </button>
        <span className={`listen-flag${listened ? ' ok' : ''}`}>{listened ? '✓ 已完整听过一遍' : '播放到 90% 以上算听完一遍'}</span>
        {!showQuiz && (
          <button className="plain small" onClick={() => setShowQuiz(true)}>
            答大意题 →
          </button>
        )}
      </div>
      {showQuiz &&
        (quiz ? (
          <div className="quiz">
            <h4>{quiz.text}</h4>
            {quiz.options.map((o, i) => {
              const result = submitted ? (i === quiz.answer ? ' right' : i === choice ? ' wrong' : '') : choice === i ? ' chosen' : '';
              return (
                <button key={i} className={`option${result}`} disabled={submitted} onClick={() => setChoice(i)}>
                  {o}
                </button>
              );
            })}
            {!submitted ? (
              <button
                className="primary"
                disabled={choice === null}
                onClick={() => {
                  setPicked(choice);
                  update({ gistAnswer: choice! });
                }}
              >
                提交
              </button>
            ) : (
              <p className="muted">
                {picked === quiz.answer ? '答对了。' : '再听一遍会更清楚。'} {quiz.explanation}
              </p>
            )}
          </div>
        ) : (
          <div className="row wrap">
            <span className="muted">自评一下：</span>
            {['大部分听懂', '听懂一半', '听懂很少'].map((t, i) => (
              <button key={t} className={state.gistAnswer === i ? 'on' : ''} onClick={() => update({ gistAnswer: i })}>
                {t}
              </button>
            ))}
          </div>
        ))}
      {(showQuiz || done) && (
        <button className="secondary" onClick={() => complete('gist')}>
          {done ? '已完成 · 下一步' : '完成盲听'}
        </button>
      )}
    </div>
  );
}
